var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 13,
    viewBox: "0 0 40 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7816_86",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7928 0.225837L8.42871 8.60471L7.0673 1.48168C6.90777 0.686668 6.27739 0.227363 5.57578 0.227363H0.0758925L0 0.58443C1.12909 0.827053 2.41152 1.21616 3.18903 1.63274C3.66452 1.88757 3.80082 2.10883 3.95725 2.71463L6.5345 12.5385H9.95121L15.1878 0.225837H11.7928ZM16.5755 0.225837L13.9023 12.5355H17.1347L19.8064 0.225837H16.5755ZM35.1073 3.55236L36.0861 8.1744H33.4051L35.1073 3.55236ZM34.6333 0.225837C34.0122 0.225837 33.4887 0.581379 33.258 1.12919L28.407 12.537H31.8005L32.4743 10.6983H36.6205L37.0108 12.537H40L37.3918 0.225837H34.6333ZM20.6861 4.06965C20.6644 5.84278 22.2907 6.83005 23.5158 7.42059C24.775 8.02333 25.1963 8.41091 25.1917 8.95109C25.1824 9.77662 24.1865 10.1413 23.2572 10.1551C21.6325 10.1795 20.6892 9.72321 19.938 9.37683L19.3526 12.0747C20.1069 12.4165 21.5008 12.714 22.9474 12.7293C26.344 12.7293 28.5635 11.0767 28.5743 8.51773C28.5882 5.26903 24.0146 5.0905 24.0455 3.63781C24.0564 3.19682 24.4823 2.72683 25.4162 2.60628C25.8793 2.54677 27.1571 2.501 28.6022 3.15715L29.1706 0.546282C28.3931 0.268563 27.3925 0 26.1457 0C22.9505 0 20.7032 1.67394 20.6846 4.06812",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7816_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0015 0H0V12.7278H40.0015V0Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaBlack);
export default __webpack_public_path__ + "static/media/visa_black.701e4cfb537563e47553f62119afa72b.svg";
export { ForwardRef as ReactComponent };